// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".popupMgm img{display:block;width:40rem;margin:auto}@media(max-width:47.4375em){.popupMgm img{width:25rem}}.popupMgm h2{margin-bottom:2rem;font-weight:700;text-align:center}.popupMgm p{margin-bottom:1rem;font-weight:400;text-align:center}.popupMgm a{text-decoration:underline}.popupMgm a:hover{text-decoration:none}.popupMgm .text-red{color:#e21d3b}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
